import { type KeyboardEvent } from "react";

import { hideKeyboard } from "./hideKeyboard";

export async function hideKeyboardOnPressEnter(event: KeyboardEvent) {
  if (event.key === "Enter") {
    await hideKeyboard();
  }
}
